import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
export default (function (object, organisationId, assetId, blockUI) {
    if (blockUI === void 0) { blockUI = true; }
    var url = applyPathVariables(EndPoints.ORGANISATION_ASSET_UPDATE_REMARK, { organisationId: organisationId, assetId: assetId });
    var request = new Request({
        method: Methods.PUT,
        url: url,
        data: object,
        withCredentials: true,
        blockUI: blockUI
    });
    return request.execute();
});
